export enum OxfordLevelOfEvidenceType {
  I = "I",
  II = "II",
  III = "III",
  IV = "IV",
  V = "V",
}
